import axios from "axios";
import { newAbortSignal } from "../../utils";
import { SessionStore } from "../../types/store/SessionStore";
import { SendEmailRequest } from "../../types/model/email";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/email`;

export const sendEmail = async (emailInfo: SendEmailRequest, file?: File | null): Promise<any> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}"
  );

  const finalURL = BASE_URL + "/send-email";

  const formData = new FormData();
  formData.append('emailData', JSON.stringify(emailInfo));
  if (file) {
    formData.append('attachment', file);
  }

  return await axios
    .post<any>(finalURL, formData, {
      headers: {
        "x-access-token": session?.accessToken,
      },
      timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        typeof AbortSignal.timeout !== "undefined"
          ? AbortSignal.timeout(
              parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)
            )
          : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
    })
    .then((response) => response.data);
};
